import React from "react";

import { Theme } from "@components/theme/Theme";

import * as ListItem from "../ListItem";
import styles from "../styles.module.css";

function WithRedTimestampOnTop(props: ListItem.Props) {
  const { description, timestamp } = props;

  return (
    <article className={styles.listItemContainer}>
      <div className={styles.mainColumn} data-skeleton-selector>
        {timestamp && (
          <Theme accentColor="red">
            <ListItem.Timestamp {...props} />
          </Theme>
        )}
        <ListItem.Text {...props} />
        {description && <ListItem.Description {...props} />}
      </div>
    </article>
  );
}
WithRedTimestampOnTop.displayName = "WithRedTimestampOnTop.Component";

export { WithRedTimestampOnTop };
